// Rule changes an alignment in force makes (Underdog allows three-letter words).
import type { PlayState } from '../play/types';
import { buildContext } from './context';
import { defsInForce } from './registry';

export interface EffectiveRules {
  minWordLength: number;
}

/** The level's rules as the alignments in force bend them. */
export function effectiveRules(state: PlayState): EffectiveRules {
  let minWordLength = state.level.rules.minWordLength;
  if (state.alignments.length > 0) {
    const ctx = buildContext(state.level, state);
    for (const def of defsInForce(ctx)) {
      if (def.rules?.minWordLength !== undefined) minWordLength = Math.min(minWordLength, def.rules.minWordLength);
    }
  }
  return { minWordLength };
}
